module.exports = __webpack_public_path__ + "img/06.1852f0d0.jpg";